<template>
        <span
        class="text-success">
        <i
            class="fa fa-check-circle-o fa-lg icon-button mr-1"
            title="Aprovar Pertinência"
            @click.stop="confirmarAprovar()"
        ></i>
        </span>
</template>

<script>

export default {
    props: {
        pleito: {
            type: Object
        },

        servicos: {
            type: Object
        },
    },

    methods: {
        confirmarAprovar() {
            this.$swal({
                title: 'Aprovar Pertinência do Pleito',
                html: `Confirma a <strong>PERTINÊNCIA</strong> do pleito <b>${this.pleito.descritivo}</b>?`,
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.value) {
                    this.aprovarPertinencia()
                }
            })
        },

        aprovarPertinencia() {
            this.$store.dispatch('addRequest')
            this.servicos.aprovarPertinencia(this.pleito.pleitoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pertinência do pleito aprovada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('listarPleitos')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}

</script>